/**
 * ./src/exercise1/Exercise1.js
 * 
 * This module serves as the **entry page for Exercise 1**, named **"Rhythmic Breathing"**.
 * It includes an animated **curtain effect** when the page loads and a **fade-out transition**
 * when navigating to the next screen.
 * 
 */



import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // useNavigate instead of useHistory
import "./Exercise1.css";
import Curtain from "../components/Curtain"; // Import the reusable Curtain component
import persongreyIcon from "./icons/person-grey.svg"; // Import the person icon

const Exercise1 = () => {  
  const [isCurtainActive, setIsCurtainActive] = useState(true);
  const [isExiting, setIsExiting] = useState(false);
  const navigate = useNavigate(); // Create a navigate function for navigation

  useEffect(() => {
    // Timer for curtain
    const curtainTimer = setTimeout(() => {
      setIsCurtainActive(false);
    }, 2000); // 2 seconds

    // // Timer for auto navigation
    // const navigationTimer = setTimeout(() => {
    //   setIsExiting(true);
    //   setTimeout(() => {
    //     navigate('/exercise1intro');
    //   }, 0);
    // }, 3000);

    // Cleanup both timers
    return () => {
      clearTimeout(curtainTimer);
    };
  }, [navigate]);

  return (
    <>
      <div className={`exercise1-page ${isExiting ? "fade-out" : ""}`}>
        {/* Display the curtain and set it to "disappear" */}
        {isCurtainActive && <Curtain disappear={true} duration={2000} />}

        {/* Text content */}
        <div className="exercise1-header">
          <h1>Exercise 1: Rhythmic Breathing</h1>
        </div>

        {/* Blue bottom area */}
        <div className="exercise1-bottom">
          <img
            className="exercise1-person"
            src={persongreyIcon}
            alt="Person Grey Icon"
          />
          <button
            className="start-exercise"
            onClick={() => {
              navigate("/exercise1intro");
              setIsExiting(true);
            }}
          >
            <b>START</b>
          </button>
        </div>
      </div>
      <div className={`page-transition ${isExiting ? "fade-in" : ""}`} />
    </>
  );
};

export default Exercise1;
